import React from 'react';
import { Dropdown, Button, Tooltip, Space, App } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

const RowActions = ({
  primary, // { label, icon, onClick, disabled, tooltip, loading }
  items,   // [{ key, label, icon, onClick, disabled, danger, hidden, confirm: { title, content } }]
  buttonSize = 'small',
  dropdownButtonType = 'text',
  screens = {} // for responsive behavior
}) => {
  const { modal } = App.useApp();
  const visibleItems = (items || []).filter(i => !i.hidden);
  const isXs = !!screens.xs;

  // On mobile, include the primary action as the first dropdown item so it's accessible
  const dropdownSourceItems = [
    ...(isXs && primary ? [{
      key: '__primary__',
      label: primary.label,
      icon: primary.icon,
      disabled: primary.disabled,
      __isPrimary: true
    }] : []),
    ...visibleItems
  ];

  const menu = {
    items: dropdownSourceItems.map(i => ({
      key: i.key,
      label: i.label,
      icon: i.icon,
      danger: i.danger,
      disabled: i.disabled
    })),
    onClick: ({ key }) => {
      const item = dropdownSourceItems.find(i => i.key === key);
      if (!item) return;
      if (item.__isPrimary) {
        primary?.onClick?.();
        return;
      }
      if (item.confirm) {
        modal.confirm({
          title: item.confirm.title,
          content: item.confirm.content,
          okText: item.confirm.okText || 'Yes',
          cancelText: item.confirm.cancelText || 'No',
          okButtonProps: item.danger ? { danger: true } : {},
          onOk: () => item.onClick?.()
        });
      } else {
        item.onClick?.();
      }
    }
  };

  return (
    <Space size={4}>
      {primary && !isXs && (
        <Tooltip title={primary.tooltip || primary.label}>
          <Button
            size={buttonSize}
            type="text"
            icon={primary.icon}
            onClick={primary.onClick}
            disabled={primary.disabled}
            loading={primary.loading}
          />
        </Tooltip>
      )}
      <Dropdown menu={menu} trigger={['click']}>
        <Button 
          size={buttonSize} 
          type={dropdownButtonType} 
          icon={<EllipsisOutlined />} 
        />
      </Dropdown>
    </Space>
  );
};

export default RowActions;
